export function toNumber(value) {
  if (typeof value === 'string') {
    return parseFloat(value.replace(/,/g, ''));
  }
  return value;
}

export function convertWhole(number) {
  if (Number.isFinite(number) && Math.floor(number) === number) {
    return parseInt(number, 10);
  }
  return parseFloat(number.toFixed(2));
}

export function humanNumber(number) {
  number = toNumber(number);
  if (number >= 1e9) return convertWhole(number / 1e9) + 'B';
  if (number >= 1e6) return convertWhole(number / 1e6) + 'M';
  if (number >= 1e3) return convertWhole(number / 1e3) + 'K';
  return convertWhole(number);
}

export function humanFormat(format, number) {
  if (number === undefined || number === null) return null;
  switch (format) {
    case 'currency_cents':
      return `$${parseFloat(number).toFixed(2)}`;
    case 'currency':
      return `$${humanNumber(number)}`;
    case 'percent':
      return `${humanNumber(number)}%`;
    default:
      return humanNumber(number);
  }
}

export function formatNumber(format, number) {
  number = toNumber(number);
  number = convertWhole(number);
  switch (format) {
    case 'currency':
      return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    case 'percent':
      return `${(number * 100).toLocaleString()}%`;
    default:
      return number.toLocaleString();
  }
}
